export default __webpack_public_path__ + "static/media/about-us-hero.b4359bbf.svg";